import apiService from '../utils/apiInterceptor';

const propertiesService = {
  getRecurrenceAvailability: async (propertyId, params) => apiService.get(`/admin/properties/${propertyId}/recurrence/availability`, { params }),
  previewRecurrence: async (propertyId, params) => apiService.get(`/admin/properties/${propertyId}/recurrence/preview`, { params }),
  createRecurrence: async (propertyId, data) => apiService.post(`/admin/properties/${propertyId}/recurrence`, data),
  getSchedoxSyncStatus: async (propertyId) => apiService.get(`/admin/properties/${propertyId}/schedox-sync`),
  startSchedoxSync: async (propertyId) => apiService.post(`/admin/properties/${propertyId}/schedox-sync`),
  getAllProperties: async () => {
    return await apiService.get('/properties');
  },

  getAllAdminProperties: async () => {
    return await apiService.get('/properties');
  },


  getSessionLog: async () => {
    return await apiService.get('/session-log');
  } ,

  getPropertyById: async (id) => {
    return await apiService.get(`/edit-property/${id}`);
  },

  createProperty: async (propertyData) => {
    return await apiService.post('/submit-property', propertyData);
  },
  addProperty: async () => {
    return await apiService.get('/add-property');
  },

  updateProperty: async (propertyData) => {
    return await apiService.post(`/submit-property`, propertyData);
  },
  updatePropertyStatus: async (id, status) => {
    return await apiService.put(`/update-property-status/${id}`, {status: status});
  },
  
  updatePropertyDetails: async (propertyData) => {
    return await apiService.post(`/update-property-details`, propertyData );
  },
  deleteProperty: async (id) => {
    return await apiService.delete(`/admin/properties/${id}`);
  }
};

export default propertiesService;
